var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircledCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2407 15.213L21.6673 32.7863L12.094 23.2397L8.33398 26.9997L21.6673 40.333L43.0007 18.9997L39.2407 15.213ZM27.0007 0.333008C12.2807 0.333008 0.333984 12.2797 0.333984 26.9997C0.333984 41.7197 12.2807 53.6663 27.0007 53.6663C41.7207 53.6663 53.6673 41.7197 53.6673 26.9997C53.6673 12.2797 41.7207 0.333008 27.0007 0.333008ZM27.0007 48.333C15.214 48.333 5.66732 38.7863 5.66732 26.9997C5.66732 15.213 15.214 5.66634 27.0007 5.66634C38.7873 5.66634 48.334 15.213 48.334 26.9997C48.334 38.7863 38.7873 48.333 27.0007 48.333Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledCheck);
export default __webpack_public_path__ + "static/media/circled-check.3b64f68c9b6020631bf7a9bfb08a3431.svg";
export { ForwardRef as ReactComponent };